import Component from'./component';import EnhanceAppEventsTracker from'./enhancers/EnhanceAppEventsTracker';export default EnhanceAppEventsTracker(Component);